import dayjs, { Dayjs } from 'dayjs';
import { Session } from '@vendasta/protos/ai_assistants/v1alpha1';

export const TimeRangeGroupLabels = {
  Today: 'INBOX.CONVERSATION_DATE_GROUPS.TODAY',
  Yesterday: 'INBOX.CONVERSATION_DATE_GROUPS.YESTERDAY',
  Last7Days: 'INBOX.CONVERSATION_DATE_GROUPS.LAST_7_DAYS',
  Last30Days: 'INBOX.CONVERSATION_DATE_GROUPS.LAST_30_DAYS',
  Older: 'INBOX.CONVERSATION_DATE_GROUPS.OLDER',
} as const;

export type TimeRangeGroupLabel = (typeof TimeRangeGroupLabels)[keyof typeof TimeRangeGroupLabels];

export interface GroupedSessions {
  readonly label: TimeRangeGroupLabel;
  readonly sessions: Session[];
}

function sessionTimestamp(session: Session): Date | undefined {
  return session.updated ?? session.created;
}

export function groupSessionsByRecency(sessions: Session[], now: Dayjs = dayjs()): GroupedSessions[] {
  if (!sessions || sessions.length === 0) {
    return [];
  }

  const yesterday = now.subtract(1, 'day');
  const sevenDaysAgo = now.subtract(7, 'day');
  const thirtyDaysAgo = now.subtract(30, 'day');

  const today: Session[] = [];
  const yesterdayGroup: Session[] = [];
  const last7Days: Session[] = [];
  const last30Days: Session[] = [];
  const older: Session[] = [];

  for (const s of sessions) {
    const t = sessionTimestamp(s);
    if (!t) continue;
    const d = dayjs(t);
    if (d.isSame(now, 'day')) {
      today.push(s);
    } else if (d.isSame(yesterday, 'day')) {
      yesterdayGroup.push(s);
    } else if (!d.isBefore(sevenDaysAgo)) {
      last7Days.push(s);
    } else if (!d.isBefore(thirtyDaysAgo)) {
      last30Days.push(s);
    } else {
      older.push(s);
    }
  }

  const groups: GroupedSessions[] = [];
  if (today.length) groups.push({ label: TimeRangeGroupLabels.Today, sessions: today });
  if (yesterdayGroup.length) groups.push({ label: TimeRangeGroupLabels.Yesterday, sessions: yesterdayGroup });
  if (last7Days.length) groups.push({ label: TimeRangeGroupLabels.Last7Days, sessions: last7Days });
  if (last30Days.length) groups.push({ label: TimeRangeGroupLabels.Last30Days, sessions: last30Days });
  if (older.length) groups.push({ label: TimeRangeGroupLabels.Older, sessions: older });
  return groups;
}
